import { useAdConfigCRUDActions } from '@mm/state/actions/AdConfigCRUDActions';
import { activeFacebookPageSelector } from '@mm/state/selectors/facebookPageSelector';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Button from '../../buttons/DeprecatedButton/DeprecatedButton';
import { ModalInstanceProps } from '../interfaces';
import { ModalBody, ModalFooter, ModalHeader } from '../modal-helpers';
import './FreeFacebookAdsCouponCongratulationsModal.scss';

export const FreeFacebookAdsCouponCongratulationsModal = (
  props: ModalInstanceProps,
) => {
  const { closeModal } = props;
  const facebookPage = useSelector(activeFacebookPageSelector);
  const { attachAdCoupon } = useAdConfigCRUDActions();

  const [mode, setMode] = useState<
    'initial' | 'finalConfirmation' | 'donationsQuestion' | 'notQualifyForPromo'
  >('initial');
  const showDonationsQuestion = () => {
    setMode('donationsQuestion');
  };
  const showFinalConfirmation = (isGovernment: boolean) => {
    setMode('finalConfirmation');
    if (facebookPage) {
      attachAdCoupon(isGovernment, facebookPage.id);
    }
  };
  const showNotQualifyForPromo = () => {
    setMode('notQualifyForPromo');
  };
  const onClickSchedule = () => {
    closeModal();
  };

  const initialContent = (
    <>
      <ModalBody className="free-facebook-ads-coupon-congratulation-modal__body">
        <div className="free-facebook-ads-coupon-congratulation-modal__body-title">
          Congratulations!
        </div>
        <div className="free-facebook-ads-coupon-congratulation-modal__body-description">
          You qualify for a free $50 Facebook Ads coupon.
        </div>
        <div className="free-facebook-ads-coupon-congratulation-modal__body-question">
          Will you be using this coupon for a government organization?
        </div>
      </ModalBody>
      <ModalFooter className="free-facebook-ads-coupon-congratulation-modal__footer">
        <Button
          blue
          className="free-facebook-ads-coupon-congratulation-modal__footer-button"
          onClick={showDonationsQuestion}
        >
          <span className="free-facebook-ads-coupon-congratulation-modal__footer-button-text">
            Yes, I’ll be using this for a government organization
          </span>
        </Button>
        <Button
          white
          className="free-facebook-ads-coupon-congratulation-modal__footer-button"
          onClick={() => showFinalConfirmation(false)}
        >
          <span className="free-facebook-ads-coupon-congratulation-modal__footer-button-text-blue">
            No
          </span>
        </Button>
      </ModalFooter>
    </>
  );

  const finalConfirmation = (
    <>
      <ModalBody className="free-facebook-ads-coupon-congratulation-modal__body">
        <div className="free-facebook-ads-coupon-congratulation-modal__body-description">
          Thanks! You will receive an email with your ads coupon code and
          further instructions. As part of this promotion you also qualify for 1
          free Premier Consultation Session. Click below to schedule your
          consultation.
        </div>
      </ModalBody>
      <ModalFooter className="free-facebook-ads-coupon-congratulation-modal__footer">
        <a
          href="https://calendly.com/mobilemonkey-sales/special-consultation"
          rel="noopener noreferrer"
          target="_blank"
        >
          <Button
            className="free-facebook-ads-coupon-congratulation-modal__footer-button"
            onClick={onClickSchedule}
            blue
          >
            Schedule my Strategy Session
          </Button>
        </a>
      </ModalFooter>
    </>
  );

  const donationsQuestion = (
    <>
      <ModalBody className="free-facebook-ads-coupon-congratulation-modal__body">
        <div className="free-facebook-ads-coupon-congratulation-modal__body-question">
          Are you permitted to accept donations?
        </div>
      </ModalBody>
      <ModalFooter className="free-facebook-ads-coupon-congratulation-modal__footer">
        <Button
          blue
          className="free-facebook-ads-coupon-congratulation-modal__footer-button"
          onClick={() => showFinalConfirmation(true)}
        >
          <span className="free-facebook-ads-coupon-congratulation-modal__footer-button-text">
            Yes
          </span>
        </Button>
        <Button
          white
          className="free-facebook-ads-coupon-congratulation-modal__footer-button"
          onClick={showNotQualifyForPromo}
        >
          <span className="free-facebook-ads-coupon-congratulation-modal__footer-button-text-blue">
            No
          </span>
        </Button>
      </ModalFooter>
    </>
  );

  const notQualifyForPromo = (
    <ModalBody className="free-facebook-ads-coupon-congratulation-modal__body">
      <div className="free-facebook-ads-coupon-congratulation-modal__body-description">
        Sorry, it seems you do not qualify for this promotion.
      </div>
    </ModalBody>
  );

  const renderContentByMode = () => {
    switch (mode) {
      case 'initial':
        return initialContent;
      case 'finalConfirmation':
        return finalConfirmation;
      case 'donationsQuestion':
        return donationsQuestion;
      case 'notQualifyForPromo':
        return notQualifyForPromo;
      default:
        return initialContent;
    }
  };

  return (
    <div className="free-facebook-ads-coupon-congratulation-modal">
      <ModalHeader className="free-facebook-ads-coupon-congratulation-modal__header" />
      {renderContentByMode()}
    </div>
  );
};
